import type { WithContext, Review } from 'schema-dts'

/**
 * Review
 * Google: https://developers.google.com/search/docs/appearance/structured-data/review-snippet?hl=ko#simple-review-example
 * Naver: https://searchadvisor.naver.com/guide/structured-data-review
 */
export const getReviewJsonLd = (
  {
    reviewBody,
    reviewRating,
    author,
    publisher,
    itemReviewed,
    aggregateRating,
  }: {
    reviewBody: string
    reviewRating?: {
      ratingValue: number
    }
    author?: {
      name: string
    }
    publisher?: {
      name: string
    }
    itemReviewed: {
      name: string
    }
    aggregateRating?: {
      ratingValue: number
      ratingCount?: number
      reviewCount?: number
    }
  },
  withContext = false,
): Review | WithContext<Review> => {
  const data = {
    '@type': 'Review',
    reviewBody,
    ...(reviewRating && reviewRating.ratingValue !== 0
      ? {
          reviewRating: {
            '@type': 'Rating',
            ratingValue: reviewRating.ratingValue,
            bestRating: 10,
          },
        }
      : {}),
    ...(author ? { author: { '@type': 'Person', name: author.name } } : {}),
    ...(publisher ? { publisher: { '@type': 'Organization', name: publisher.name } } : {}),
    itemReviewed: {
      '@type': 'MedicalClinic',
      name: itemReviewed.name,
      ...(aggregateRating && aggregateRating.ratingValue !== 0
        ? {
            aggregateRating: {
              '@type': 'AggregateRating',
              ...aggregateRating,
              bestRating: 10,
            },
          }
        : {}),
    },
  }

  if (withContext) {
    return { ...data, '@context': 'https://schema.org' } as WithContext<Review>
  }

  return data as Review
}
